export default "__VITE_ASSET__C$Am6aUG__"